import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgbDropdownModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { SharedModule } from '@shared/share.module';
import { SpaceCardComponent } from './space-card/space-card.component';
import { SpacesComponent } from './spaces.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: '',
        component: SpacesComponent,
        outlet: 'dashboard',
      },
    ],
  },
];

@NgModule({
  declarations: [SpacesComponent, SpaceCardComponent],
  imports: [NgbPopoverModule, CommonModule, SharedModule, NgbDropdownModule, RouterModule.forChild(routes)],
})
export class SpacesModule {}
